import React, { useState, useEffect } from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import {
	Button,
	makeStyles,
	TableFooter,
	TableCell,
	TableRow,
	CircularProgress,
} from "@material-ui/core";

import { Dropdown, Modal } from "react-bootstrap";
import {
	DropdownCustomToggler,
	DropdownMenu4,
} from "../../_metronic/_partials/dropdowns";

import Moment from "moment";
import { getMyLicenseList, uptLicense } from "../modules/api";
import MUIDataTable from "mui-datatables";
import { isObject } from "lodash";

export function LicenseManage() {
	const [listLoading, setListLoading] = useState(false);
	const [isShow, setIsShow] = useState(false);
	const [licenseList, setLicenseList] = useState([]);
	const [selectRowData, setSelectRowData] = useState([]);
	const [botList, setBotList] = useState([]);
	const [botStatus, setBotStatus] = useState(0);

	const useStyles = makeStyles((theme) => ({
		container: {
			display: "flex",
			flexWrap: "wrap",
		},
		textField: {
			marginLeft: theme.spacing(1),
			marginRight: theme.spacing(1),
			width: 200,
		},
		centeredHeader: {
			"& span": {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				fontSize: 15,
				fontWeight: "bold",
			},
		},
	}));

	const classes = useStyles();

	const fetchData = async () => {
		try {
			const licenseResult = await getMyLicenseList();
			console.log("licenseResult", licenseResult);
			setLicenseList(licenseResult.data);

			const nowDate = Moment(new Date()).format("YYYY-MM-DD");

			let list = [];
			let idx = 0;
			licenseResult.data.map((data, index) => {
				if (data.deletedAt === null) {
					var obj = new Object();
					obj.idx = idx + 1;
					obj.no = data.no;
					obj.botAmount = data.botAmount + "Bot";
					obj.term = data.term + "년";
					obj.licenseNumber = data.licenseNumber;
					obj.botCheck =
						data.botList.length + "Bot / " + data.botAmount + "Bot";
					obj.useDate =
						Moment(data.startAt).format("YYYY-MM-DD") +
						" ~ " +
						Moment(data.endAt).format("YYYY-MM-DD");
					obj.botStatus =
						Moment(data.endAt).format("YYYY-MM-DD") < nowDate
							? "expire"
							: data.status;

					obj.createdAt = data.createdAt
						? Moment(data.createdAt).format("YYYY-MM-DD HH:mm:ss")
						: "-";
					obj.botList = data.botList;
					list.push(obj);
				}
			});
			setLicenseList(list);
		} catch (e) {
			console.log(e);
			// Handle error
		}
	};

	useEffect(() => {
		setListLoading(true);
		setTimeout(async () => {
			fetchData();
			setListLoading(false);
		}, 1000);
	}, []);

	const toggleShow = () => {
		setIsShow(!isShow);
	};

	const doUse = async (value, status) => {
		if (status === 'Y') {
			alert("해당 라이선스는 현재 사용 중입니다.");

			return;
		} else if (status === 'expire') {
			alert("해당 라이선스는 현재 기간이 만료 되었으므로 사용이 불가합니다.");

			return;
		}

		const param = {
			status: "Y",
		};

		const res = await uptLicense(value, param);
		// console.log("doUse", res);
		if (res.result) {
			alert("정상적으로 수정되었습니다.");
			fetchData();
		} else {
			alert("정상적으로 수정되지 않았습니다.");
			return;
		}
	};

	const doNoUse = async (value, status) => {
		if (status === 'N') {
			alert("해당 라이선스는 현재 사용중지 중입니다.");

			return;
		} else if (status === 'expire') {
			alert("해당 라이선스는 현재 기간이 만료 되었으므로 사용중지가 불가합니다.");

			return;
		}

		const param = {
			status: "N",
		};
		const res = await uptLicense(value, param);
		// console.log("doNoUse", res);
		if (res.result) {
			alert("정상적으로 수정되었습니다.");
			fetchData();
		} else {
			alert("정상적으로 수정되지 않았습니다.");
			return;
		}
	};

	const columns = [
		// {
		// 	name: "idx",
		// 	label: "번호",
		// 	options: {
		// 		filter: true,
		// 		sort: true,
		// 		setCellProps: () => ({ style: { textAlign: "center" } }),
		// 		setCellHeaderProps: () => ({
		// 			className: classes.centeredHeader,
		// 		}),
		// 	},
		// },
		{
			name: "botAmount",
			label: "Bot 수",
			options: {
				filter: true,
				sort: true,
				setCellProps: () => ({ style: { textAlign: "center" } }),
				setCellHeaderProps: () => ({
					className: classes.centeredHeader,
				}),
			},
		},
		{
			name: "term",
			label: "사용기간",
			options: {
				filter: true,
				sort: true,
				setCellProps: () => ({ style: { textAlign: "center" } }),
				setCellHeaderProps: () => ({
					className: classes.centeredHeader,
				}),
			},
		},
		{
			name: "useDate",
			label: "유효기간",
			options: {
				filter: true,
				sort: true,
				setCellProps: () => ({ style: { textAlign: "center" } }),
				setCellHeaderProps: () => ({
					className: classes.centeredHeader,
				}),
			},
		},
		{
			name: "licenseNumber",
			label: "라이선스",
			options: {
				filter: true,
				sort: true,
				setCellProps: () => ({ style: { textAlign: "center" } }),
				setCellHeaderProps: () => ({
					className: classes.centeredHeader,
				}),
			},
		},
		{
			name: "botList",
			options: {
				filter: false,
				sort: false,
				display: false,
				viewColumns: false,
			},
		},
		{
			name: "botStatus",
			label: "라이선스 상태",
			options: {
				filter: true,
				sort: true,
				setCellProps: () => ({ style: { textAlign: "center" } }),
				setCellHeaderProps: () => ({
					className: classes.centeredHeader,
				}),
				customBodyRender: (value, meta) => {
					let textLabel;
					let textColor;

					if (value === "Y") {
						textLabel = "사용";
						textColor = "label-success";
					} else if (value === "N") {
						textLabel = "사용중지";
						textColor = "label-primary";
					} else if (value === "expire") {
						textLabel = "기간만료";
						textColor = "label-secondary";
					}
					return (
						<div>
							<span className={"label label-xl label-inline " + textColor}>
								{textLabel}
							</span>
						</div>
					);
				},
			},
		},
		{
			name: "botCheck",
			label: "Bot 확인",
			options: {
				filter: true,
				sort: true,
				setCellProps: () => ({
					style: {
						textAlign: "center",
						fontWeight: "bold",
						textDecorationLine: "underline",
					},
				}),
				setCellHeaderProps: () => ({
					className: classes.centeredHeader,
				}),
			},
		},
		{
			name: "createdAt",
			label: "발급일시",
			options: {
				filter: true,
				sort: true,
				setCellProps: () => ({ style: { textAlign: "center" } }),
				setCellHeaderProps: () => ({
					className: classes.centeredHeader,
				}),
			},
		},
		{
			name: "no",
			options: {
				filter: false,
				sort: false,
				display: false,
				viewColumns: false,
			},
		},
		{
			name: "action",
			label: "작업",
			options: {
				filter: false,
				sort: false,
				setCellProps: () => ({
					style: { textAlign: "center" },
				}),
				setCellHeaderProps: () => ({
					style: { textAlign: "center", fontSize: 15, fontWeight: "bold" },
				}),
				customBodyRender: (value, meta) => {
					// if (userNo.toString() === meta.rowData[6].toString()) {
					return (
						<div className="card-toolbar">
							<Dropdown className="dropdown-inline">
								<Dropdown.Toggle
									className="btn btn-clean btn-hover-light-primary btn-sm btn-icon"
									variant="transparent"
									id="dropdown-autoClose-true"
									as={DropdownCustomToggler}
								>
									<i className="ki ki-bold-more-hor" />
								</Dropdown.Toggle>
								<Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
									{/* <ul className="navi"> */}
									<Dropdown.Item
										className="navi-item"
										onClick={() => {
											console.log("사용", meta.rowData);
											doUse(meta.rowData[8], meta.rowData[5]);
										}}
									>
										사용
									</Dropdown.Item>
									<Dropdown.Item
										className="navi-item"
										onClick={() => {
											console.log("사용중지", meta.rowData);
											doNoUse(meta.rowData[8], meta.rowData[5]);
										}}
									>
										사용중지
									</Dropdown.Item>
									{/* <Dropdown.Item
										className="navi-item"
										onClick={() => {
											// singleUpdate(meta.rowData[6], meta.rowData[1]);
										}}
									>
										{meta.rowData[1] === 1 ? "사용중지" : "사용"}
									</Dropdown.Item> */}
									{/* </ul> */}
								</Dropdown.Menu>
							</Dropdown>
						</div>
					);
					// }
				},
			},
		},
	];

	const options = {
		print: false,
		download: false,
		filter: false,
		viewColumns: false,
		rowsPerPage: 15,
		rowsPerPageOptions: [],
		selectToolbarPlacement: "none",
		selectableRows: "none",
		onCellClick: (cellData, cellMeta) => {
			if (cellMeta.colIndex === 6) {
				toggleShow();
			}
		},
		onRowClick: (rowData, rowState, rowIndex) => {
			setBotStatus(licenseList[rowState.rowIndex].botStatus);
			setSelectRowData(rowData);
			setBotList(rowData[4]);
		},
		textLabels: {
			body: {
				noMatch: listLoading ? (
					<CircularProgress size={25} color={"inherit"} />
				) : licenseList ? (
					""
				) : (
					"검색 결과가 없습니다."
				),
			},
		},
	};

	const styles = {
		border: "solid 2px #ff6f5e",
		padding: 10,
		borderRadius: 10,
		backgroundColor: "rgb(252, 230, 227)",
	};

	const noStyles = {
		border: "solid 2px #fff",
		padding: 10,
		borderRadius: 10,
		backgroundColor: "rgb(255,255,255)",
	};

	return (
		<div id="pageid31">
			<Modal show={isShow}>
				<Modal.Header closeButton>
					<Modal.Title id="example-modal-sizes-title-lg">Bot 확인</Modal.Title>
				</Modal.Header>
				<Modal.Body className="text-center">
					<div className="d-flex align-items-center justify-content-between mb-5">
						<p className="mb-0 license-number">{selectRowData[3]}</p>
						<p className="mb-0 font-weight-bold">{selectRowData[6]}</p>
					</div>
					<table>
						<thead>
							<tr>
								<th>Bot ID</th>
								<th>Bot 상태</th>
							</tr>
						</thead>
						<tbody>
							{botList.length > 0 &&
								botList.map((data, index) => {
									console.log("selectRowData", selectRowData)
									let textLabel;
									let textColor;

									if (botStatus == "N") {
										textLabel = "사용중지";
										textColor = "label-primary";
									}
									else if (botStatus == "expire") {
										textLabel = "기간만료";
										textColor = "label-secondary";
									}
									else {
										if (data.accountStatus === 2) {
											textLabel = "사용";
											textColor = "label-success";
										} else if (data.accountStatus === 1) {
											textLabel = "사용중지";
											textColor = "label-primary";
										} else if (data.accountStatus === 3) {
											textLabel = "기간만료";
											textColor = "label-secondary";
										}
                                    }
									return (
										<tr>
											<td>{data.loginId}</td>
											<td>
												<span
													className={"label label-xl label-inline " + textColor}
												>
													{textLabel}
												</span>
											</td>
										</tr>
									);
								})}
							{botList.length === 0 && (
								<tr>
									<td colSpan="2">
										<span>등록된 Bot이 없습니다.</span>
									</td>
								</tr>
							)}
						</tbody>
					</table>
				</Modal.Body>
				<Modal.Footer>
					<div>
						<button
							type="button"
							onClick={toggleShow}
							className="btn btn-primary btn-elevate"
						>
							확인
						</button>
					</div>
				</Modal.Footer>
			</Modal>
			{/* D1: Bot 개수 선택 시 라이선스 상세 모달 활성화 끝 */}
			<div style={{ marginTop: 30 }}>
				<h3 className="card-label font-weight-bolder text-dark d-flex align-items-center mb-0">
					라이선스 관리
				</h3>
			</div>

			<div className="gutter-b" style={{ marginTop: "50px" }}>
				<div className="table-responsive">
					<MUIDataTable
						// title={"Bot 관리"}
						data={licenseList}
						columns={columns}
						options={options}
					/>
				</div>
			</div>
		</div>
	);
}
export default LicenseManage;
